module.exports = __webpack_public_path__ + "img/MV.2c73a172.png";